import Artboard from './board'
import ArtboardImage from './image'
import ArtboardText from './text'

export { ArtboardImage, ArtboardText } // layers

export default Artboard
